import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import JiraSpaPageContainerQuery from './src/common/ui/page-container/__generated__/JiraSpaPageContainerQuery.graphql';

export const spaEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-page-container" */ './src/common/ui/page-container/JiraSpaPageContainer.tsx'
			).then(({ JiraSpaPageContainerEntry }) => JiraSpaPageContainerEntry),
		// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
		{ includeInShellOnlySsrBundle: true, entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: (props: EntryPointRouteParams) => ({
		queries: {
			queryReference: {
				parameters: JiraSpaPageContainerQuery,
				variables: {
					cloudId: props?.tenantContext?.cloudId,
				},
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
			},
		},
	}),
});
